import { adaptCategories } from './utils';

export const panelDynamicConfig = [
  {
    name: 'isInReport:switch',
    displayName: 'Should question be visible in Report?',
    default: false,
    category: 'Reports',
  },

  {
    name: 'mainChart',
    displayName: 'Choose Main chart',
    choices: ['bar-stacked'],
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
  {
    name: 'secondaryChart',
    default: 'none',
    displayName: 'Choose Secondary chart',
    choices: ['none', 'bar'],
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.mainChart !== 'none';
    },
    dependsOn: ['isInReport', 'mainChart'],
  },
  {
    name: 'isCollapsable:switch',
    displayName: 'is Collapsable display?',
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport && obj.secondaryChart !== 'none';
    },
    dependsOn: ['isInReport', 'secondaryChart'],
  },
  {
    name: 'mainCategory',
    default: 'none',
    displayName: 'Choose Main category',
    choices: function (obj: any) {
      const { reportCategories } = obj.survey;

      if (reportCategories) {
        return ['none', ...adaptCategories(reportCategories.categories)] || [];
      }

      return [];
    },
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
  {
    name: 'secondaryCategory',
    default: 'none',
    displayName: 'Choose Secondary category',
    choices: function (obj: any) {
      const { reportCategories } = obj.survey;

      if (reportCategories) {
        return (
          ['none', ...adaptCategories(reportCategories.subcategories)] || []
        );
      }

      return [];
    },
    category: 'Reports',
    visibleIf: function (obj: any) {
      return obj.isInReport;
    },
    dependsOn: ['isInReport'],
  },
];
